import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { StudioDetailsAll } from '../model/types';

export const getStudioDetailsAllAPI = async () => {
  const response = await baseAPI.get<StudioDetailsAll>(`/studios/data/all`);
  return response.data;
};

export const useGetStudioDetailsAll = () => {
  return useQuery({
    queryKey: [KEYS.STUDIO_DETAILS_ALL],
    queryFn: () => getStudioDetailsAllAPI(),
    staleTime: 1000 * 60 * 5,
  });
};
